import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { getCollectors } from "../../redux/actions/collector";
import { tableTheme } from "../../helpers/tableTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Datetime from "react-datetime";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import dayjs from "dayjs";

import {
  Form,
  Card,
  Col,
  InputGroup,
  Button,
  Row,
  Spinner,
} from "@themesberg/react-bootstrap";
import { clearBatchByDate, getBatchByDate } from "../../redux/actions/batch";
import CustomDashboardLoader from "../../components/CustomDashboardLoader";
import CustomErrorView from "../../components/CustomErrorView";
import ColorComponent from "../../components/ColorComponent";

const columns = [
  "Batch Id",
  "Collector Name",
  "Collector Contact Number",
  "Date",
  {
    name: "Status",
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  "Total Transactions",
];

//NOT USED
function ViewBatchDate({ history, match }) {
  const dispatch = useDispatch();
  // const collectorData = useSelector((state) => state.collector.collectorData);
  const [batchDate, setBatchDate] = useState("");
  const [errorBatchDate, setErrorBatchDate] = useState("");
  const [showErrPage, setShowErrPage] = useState(false);

  const batchData = useSelector((state) => state.batch.batchData);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {};
  }, []);

  useEffect(() => {
    const someDate = match.params?.date;
    if (!someDate) {
      setShowErrPage(true);
    } else {
      setBatchDate(someDate);
      setIsLoading(true);
      dispatch(getBatchByDate(someDate)).then(() => {
        setIsLoading(false);
      });
    }
    return () => {
      dispatch(clearBatchByDate());
    };
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/batch/transaction/${rowData[0]}`);
  };
  const options = {
    filterType: "checkbox",
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive:"standard"
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <>
        <div>
          <MuiThemeProvider theme={tableTheme}>
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "50vh",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <MUIDataTable
                title={`Batches created on ${
                  batchDate !== ""
                    ? dayjs(batchDate).format("DD MMMM, YYYY")
                    : ""
                }`}
                data={batchData}
                columns={columns}
                options={options}
              />
            )}
          </MuiThemeProvider>
        </div>
      </>
    );
  }
}

export default ViewBatchDate;
